import { jsx as C } from "react/jsx-runtime";
const l = ({
  width: o,
  height: t,
  className: n
}) => /* @__PURE__ */ C(
  "svg",
  {
    className: n,
    fill: "none",
    height: t,
    viewBox: "0 0 36 40",
    width: o,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ C(
      "path",
      {
        d: "M21.0283 27.7801C19.9435 28.0215 18.8379 28.158 17.7269 28.1874C15.96 28.2059 14.2258 27.7124 12.7355 26.767C11.2649 25.8369 10.0741 24.5283 9.28909 22.9794C8.45125 21.3062 8.03134 19.4563 8.06502 17.5868C8.03462 15.7071 8.45422 13.8472 9.28909 12.1611C10.0626 10.6044 11.2559 9.2928 12.7355 8.37338C14.2338 7.45027 15.9652 6.97167 17.7269 6.9934C19.4701 6.96428 21.1838 7.44392 22.6564 8.37338C24.1052 9.3046 25.283 10.5985 26.0719 12.1255C26.8089 13.7254 27.213 15.4573 27.26 17.2169C27.307 18.9765 26.9958 20.7273 26.3453 22.3639C26.2549 22.5675 26.1789 22.7781 26.0719 22.977C25.8646 23.3152 25.6384 23.6416 25.3945 23.9547C28.1158 24.2069 30.719 25.183 32.9315 26.7811H32.9529C34.4929 23.988 35.307 20.8556 35.3211 17.6692C35.3352 14.4827 34.5489 11.3433 33.0337 8.53679C31.5472 5.92238 29.3749 3.75969 26.7494 2.28013C23.9675 0.783588 20.8553 0 17.6936 0C14.5318 0 11.4197 0.783588 8.63783 2.28013C6.00816 3.76559 3.82656 5.92618 2.32022 8.53679C0.797823 11.3131 0 14.4257 0 17.5891C0 20.7525 0.797823 23.8653 2.32022 26.6416C3.82659 29.2528 6.00814 31.4141 8.63783 32.9006C11.412 34.4469 14.5483 35.2326 17.7269 35.1778C18.8861 35.1801 20.0433 35.0811 21.1852 34.8819C22.4215 34.6714 23.6923 34.8081 24.8551 35.2763C26.018 35.7446 27.027 36.5262 27.769 37.5333L29.6087 40L36 35.1707C33.2001 31.4186 30.6973 27.9459 25.656 27.3588C24.1008 27.2576 22.5393 27.3998 21.0283 27.7801Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  l as Content
};
